"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

require("core-js/modules/es.array.concat");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _moment = _interopRequireDefault(require("moment"));

var _spinner = _interopRequireDefault(require("@audacious/components/lib/components/spinner"));

var _isEqual = _interopRequireDefault(require("lodash/isEqual"));

var _subHeading = _interopRequireDefault(require("@audacious/components/lib/components/typography/sub-heading"));

var _grid = require("@audacious/components/lib/components/grid");

var _button = _interopRequireDefault(require("@audacious/components/lib/components/button"));

var _simpleTable = _interopRequireDefault(require("@audacious/components/lib/components/table/simple/simple-table"));

var _tableMessage = _interopRequireDefault(require("@audacious/components/lib/components/table-message"));

var _text = _interopRequireDefault(require("@audacious/components/lib/components/text"));

var _chip = _interopRequireDefault(require("@audacious/components/lib/components/chip"));

var _page = require("@audacious/components/lib/components/page");

var _faFileCsv = require("@audacious/icons/regular/faFileCsv");

var _connectToStores = _interopRequireDefault(require("fluxible-addons-react/connectToStores"));

var _reactRouterDom = require("react-router-dom");

var _reportsPropType = _interopRequireDefault(require("./reports-prop-type"));

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

var _ref =
/*#__PURE__*/

/*#__PURE__*/
_react.default.createElement(_chip.default, {
  color: "success",
  size: "xs"
}, "Success");

var _ref2 =
/*#__PURE__*/

/*#__PURE__*/
_react.default.createElement(_chip.default, {
  color: "danger",
  size: "xs"
}, "Failed");

var _ref5 =
/*#__PURE__*/

/*#__PURE__*/
_react.default.createElement("div", null, "\xA0\xA0--");

var _ref6 =
/*#__PURE__*/

/*#__PURE__*/
_react.default.createElement(_spinner.default, {
  id: "panel-spinner",
  variant: "overlay",
  spaceFromTop: "sm"
});

var _ref7 =
/*#__PURE__*/

/*#__PURE__*/
_react.default.createElement(_grid.Column, {
  width: "fill"
}, /*#__PURE__*/_react.default.createElement(_subHeading.default, {
  id: "missing-persons-reports-header",
  level: "5"
}, "Missing Persons Reports"));

var _ref8 =
/*#__PURE__*/

/*#__PURE__*/
_react.default.createElement(_tableMessage.default, {
  header: "No reports to display."
});

var Reports = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(Reports, _React$Component);

  var _super = _createSuper(Reports);

  function Reports(props) {
    var _this;

    (0, _classCallCheck2.default)(this, Reports);
    _this = _super.call(this, props);
    _this.state = {};
    _this.handleCreateReportClick = _this.handleCreateReportClick.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleDownloadReportClick = _this.handleDownloadReportClick.bind((0, _assertThisInitialized2.default)(_this));
    _this.COLUMNS = [{
      headerBody: 'Report Name',
      cellValuePath: 'reportName',
      cellFilterPath: 'reportName',
      cellSortPath: 'reportNumber',
      sortable: true,
      renderCell: function renderCell(cellValue, rowValue) {
        var orgName = rowValue.orgName,
            reportNumber = rowValue.reportNumber,
            reportName = rowValue.reportName;
        var name = "[".concat(orgName, "] ").concat(reportName, " ").concat(reportNumber);
        return /*#__PURE__*/_react.default.createElement(_text.default, {
          size: "lg",
          weight: "semi-bold"
        }, name);
      }
    }, {
      headerBody: 'Source Panel',
      cellValuePath: 'sourcePanel',
      cellFilterPath: 'sourcePanel'
    }, {
      headerBody: 'Report Date Range',
      cellValuePath: 'reportDateRange',
      cellFilterPath: 'reportDateRange'
    }, {
      headerBody: 'Date Created',
      cellValuePath: 'dateCreated',
      cellFilterPath: 'dateCreated',
      cellSortPath: 'dateCreated',
      sortable: true,
      width: '150px',
      renderCell: function renderCell(cellValue) {
        var formattedDate = (0, _moment.default)(cellValue).format('MM/DD/YYYY');
        return /*#__PURE__*/_react.default.createElement(_text.default, {
          size: "lg"
        }, formattedDate);
      }
    }, {
      headerBody: 'Status',
      cellValuePath: 'status',
      cellFilterPath: 'status',
      sortable: true,
      width: '110px',
      renderCell: function renderCell(cellValue) {
        var result = '-';

        if (cellValue === 'Success') {
          result = _ref;
        } else if (cellValue === 'Failed') {
          result = _ref2;
        }

        return result;
      }
    }, {
      headerBody: 'Report',
      cellValuePath: ['status', 'report_id'],
      width: '135px',
      renderCell: function renderCell(_ref3) {
        var _ref4 = (0, _slicedToArray2.default)(_ref3, 2),
            status = _ref4[0],
            reportId = _ref4[1];

        if ((0, _isEqual.default)(status, 'Success')) {
          return /*#__PURE__*/_react.default.createElement(_button.default, {
            color: "primary",
            variant: "none",
            leftIcon: _faFileCsv.faFileCsv,
            size: "2xs",
            onClick: function onClick() {
              return _this.handleDownloadReportClick(reportId);
            }
          }, "Download");
        }

        if ((0, _isEqual.default)(status, 'Failed')) {
          return _ref5;
        }

        return null;
      }
    }];
    return _this;
  }

  (0, _createClass2.default)(Reports, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var service = this.context.service;
      service.missingPersons.getAllReports();
    } // componentDidUpdate(prevProps) {
    //     const { executeAction } = this.context;
    //     const { reports, successfulReportCreation } = this.props;
    //     if (!prevProps.successfulReportCreation && successfulReportCreation) {
    //         if ((isEqual(get(reports, '[0].status')), 'processing')) {
    //             const showErrorMessage = Math.random() > 0.5;
    //             if (showErrorMessage) {
    //                 executeAction(showNotification, {
    //                     heading: 'Create Report Unsuccessful',
    //                     message: 'We are unable to create your new report.',
    //                     color: 'danger',
    //                 });
    //             } else {
    //                 executeAction(showNotification, {
    //                     heading: 'Report Requested Successfully',
    //                     message:
    //                         'Please check the status of your report in the reports table.',
    //                     color: 'success',
    //                 });
    //             }
    //         }
    //     }
    // }

  }, {
    key: "handleDownloadReportClick",
    value: function handleDownloadReportClick(mpListId) {
      var service = this.context.service;
      service.missingPersons.getReport({
        data: {
          id: mpListId
        }
      });
    } // eslint-disable-next-line class-methods-use-this

  }, {
    key: "handleCreateReportClick",
    value: function handleCreateReportClick() {
      var service = this.context.service;
      service.missingPersons.createReport();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          reports = _this$props.reports,
          loadingReports = _this$props.loadingReports,
          panels = _this$props.panels;

      if (loadingReports) {
        return _ref6;
      }

      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_page.PageContainerGroup, null, /*#__PURE__*/_react.default.createElement(_grid.Row, {
        className: "home-content-header",
        gutter: "24",
        enableAfter: true
      }, _ref7, /*#__PURE__*/_react.default.createElement(_grid.Column, {
        width: "content"
      }, /*#__PURE__*/_react.default.createElement(_button.default, {
        id: "create-report-button",
        variant: "outline",
        color: "primary",
        onClick: this.handleCreateReportClick,
        disabled: !panels || panels.length === 0
      }, "Create Report")))), /*#__PURE__*/_react.default.createElement(_simpleTable.default, {
        id: "panels-table",
        items: reports,
        columns: this.COLUMNS,
        minWidth: 1000,
        alwaysShowHeaders: true,
        initialSortPath: "dateCreatedTimestamp",
        initialSortDescending: true,
        pageTable: true,
        useParentScroll: true,
        stickyColumns: 1
      }), reports.length === 0 ? _ref8 : null);
    }
  }, {
    key: "__reactstandin__regenerateByEval",
    value: // @ts-ignore
    function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }]);
  return Reports;
}(_react.default.Component);

Reports.contextTypes = {
  executeAction: _propTypes.default.func.isRequired,
  service: _propTypes.default.objectOf(_propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.object])).isRequired
};
var BoundComponent = (0, _connectToStores.default)(Reports, ['MissingPersonsStore'], function (context) {
  var missingPersonsStore = context.getStore('MissingPersonsStore');
  var reports = missingPersonsStore.getReports();
  var loadingReports = missingPersonsStore.getLoadingReports(); // const successfulReportCreation = missingPersonsStore.getSuccessfulReportCreation();

  return {
    reports: reports,
    // successfulReportCreation,
    loadingReports: loadingReports
  };
});

var _default = (0, _reactRouterDom.withRouter)(BoundComponent);

var _default2 = _default; // export default Reports;

exports.default = _default2;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(Reports, "Reports", "/builds/pulse-platform/pulse-missingperson-web-application/src/components/home-page/reports/reports.jsx");
  reactHotLoader.register(BoundComponent, "BoundComponent", "/builds/pulse-platform/pulse-missingperson-web-application/src/components/home-page/reports/reports.jsx");
  reactHotLoader.register(_default, "default", "/builds/pulse-platform/pulse-missingperson-web-application/src/components/home-page/reports/reports.jsx");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();